module.exports = __webpack_public_path__ + "img/hdsww.111c7414.jpg";